import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { MenuItem, Select } from '@material-ui/core';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import clsx from 'clsx';
import ExpandMore from '@material-ui/icons/ExpandMore';
import { useDispatch, useSelector } from 'react-redux';
import { selectCountry } from '../Reducers/Country/Actions';
import networkConf from '../Config/network';

const useStyles = makeStyles((theme) => ({
  root: {
    color: 'white',
    borderRadius: 4,
    border: '1px solid hsla(0,0%,100%,.1)',
  },
  lightRoot: {
    color: 'inherit',
    border: '1px solid #ddd',
  },
  select: ({ fullWidth }) => ({
    padding: '.75rem 1rem',
    display: 'flex',
    alignItems: 'center',
    [theme.breakpoints.down(992)]: fullWidth
      ? {}
      : {
          height: '1.25rem',
          width: '11.875rem',
        },
  }),
  icon: {
    fill: 'white',
  },
  lightIcon: {
    fill: 'black',
  },
  paper: {
    background: '#202f31',
    boxShadow: 'none',
    border: '1px solid hsla(0,0%,100%,.1)',
    borderRadius: 4,
    '& ul': {
      padding: 0,
    },
  },
  lightPaper: {
    background: '#FFF',
    border: '1px solid #ddd',
    '& ul li': {
      color: 'black !important',
    },
  },
  flag: {
    paddingRight: 10,
    height: 28,
  },
}));

const StyledMenuItem = withStyles({
  root: {
    color: 'white',
    fontFamily: 'Aeonik,sans-serif',
    padding: '.75rem 1rem',
    '& + $root': {
      borderTop: '1px solid hsla(0,0%,100%,.1)',
    },
  },
})(MenuItem);

function LanguageSelect({ className, lightMode, ...props }) {
  const { i18n } = useTranslation();
  const changeLanguage = (countryIdentifier) => {
    dispatch(selectCountry(countryIdentifier));
  };
  const classes = useStyles(props);
  const dispatch = useDispatch();
  const { countries, selectedCountry } = useSelector((state) => state.Country);

  useEffect(() => {
    if (countries.length > 0) {
      countries.map((country) => {
        if (country.identifier === selectedCountry) {
          i18n.changeLanguage(country.language);
        }
      });
    }
  }, [selectedCountry]);

  return (
    <Select
      onChange={(evt) => changeLanguage(evt.target.value)}
      value={selectedCountry}
      className={clsx(classes.root, lightMode ? classes.lightRoot : '', className)}
      disableUnderline
      IconComponent={ExpandMore}
      inputProps={{
        classes: {
          icon: clsx(classes.icon, lightMode ? classes.lightIcon : ''),
        },
      }}
      MenuProps={{
        anchorOrigin: {
          vertical: 'top',
          horizontal: 'center',
        },
        transformOrigin: {
          vertical: 'bottom',
          horizontal: 'center',
        },
        getContentAnchorEl: null,
        PaperProps: {
          square: true,
        },
        classes: {
          paper: clsx(classes.paper, lightMode ? classes.lightPaper : ''),
        },
      }}
      classes={{
        select: classes.select,
      }}
      {...props}
    >
      {countries.length > 0 &&
        countries.map((country) =>
          country.identifier === 'global' ? (
            <StyledMenuItem value={country.identifier} key={country.identifier}>
              <img
                src={
                  networkConf.baseURL +
                  '/' +
                  country.flag.replace(/(\.svg)/, lightMode ? '_dark.svg' : '_light.svg')
                }
                className={classes.flag}
              />
              Global
            </StyledMenuItem>
          ) : (
            <StyledMenuItem value={country.identifier} key={country.identifier}>
              <img src={networkConf.baseURL + '/' + country.flag} className={classes.flag} />
              {country.label ? country.label : country.identifier}
            </StyledMenuItem>
          )
        )}
    </Select>
  );
}

LanguageSelect.propTypes = {
  className: PropTypes.string,
  lightMode: PropTypes.bool,
};

export default LanguageSelect;
